import { BooleanFilterOperationType } from './boolean';
import { DateFieldFilterOperationType } from './date';
import { NumberFilterOperationType } from './number';
import { SelectFilterOperationType } from './select';
import { TextFieldFilterOperationType } from './text';

export enum Operation {
  GreaterThan = 'greaterThan',
  LessThan = 'lessThan',
  IsEmpty = 'isEmpty',
  IsNotEmpty = 'isNotEmpty',
  Value = 'value',
  IsNot = 'isNot',
  HasValue = 'hasValue',
  Contains = 'contains',
  NotContains = 'notContains',
  IsNull = 'isNull',
  OneOf = 'oneOf',
  NoneOf = 'noneOf',
}

export enum NumberOperationType {
  GreaterThan = 'greaterThan',
  LessThan = 'lessThan',
  IsEmpty = 'isEmpty',
  IsNotEmpty = 'isNotEmpty',
  Value = 'value',
}

export type FilterOperationType =
  | NumberFilterOperationType
  | SelectFilterOperationType
  | BooleanFilterOperationType
  | TextFieldFilterOperationType
  | DateFieldFilterOperationType;
